<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <form class="edit-xmla-subscription-dialog-form">
    <mat-form-field>
      <mat-label>Name (required, unique, 40 character max)</mat-label>
      <input
        matInput
        name="data.xmlaSubscriptionTypeName"
        [(ngModel)]="data.xmlaSubscriptionTypeName"
      /> </mat-form-field
    ><br />
    <mat-form-field>
      <mat-label>Description (required)</mat-label>
      <input
        matInput
        name="data.description"
        [(ngModel)]="data.description"
      /> </mat-form-field
    ><br />
    <ng-container>
      <button mat-raised-button color="primary" (click)="editLicense()">
        Edit License
      </button> </ng-container
    ><br />
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    Save Subscription
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
